import { BCMSRecord, DisabledPrompt, Link, useBCMSContext, useRoute } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIButton } from "components/ui";
import Classes, { UserAccount } from "model";
import { SVGAsset } from "res";

import "./styles.css";

export default function ManageRecipientsContent(props) {
    const context = useBCMSContext();
    const navigate = useRoute();
    BCMSRecord.globalControllerFor(Classes, context);

    const { phones, emails } = UserAccount.initAll().reduce((result, account) => {
        const onClick = evt => navigate(`/advancedAlerts/manageRecipient/${ account.id }`);

        if (account.id !== "0") {
            result.phones.push(<DisabledRecipientItem key={ `Recipient_Phone_${ account.id }` } dataPoint={ `Recipient_Phone_${ account.id }` } account={ account } accountProp="workPhoneNumber" />);
            result.emails.push(<DisabledRecipientItem key={ `Recipient_Email_${ account.id }` } dataPoint={ `Recipient_Email_${ account.id }` } account={ account } accountProp="emailAddress" />);

            return result;
        }

        result.phones.push(<DisabledRecipientItem key={ `Recipient_Phone_${ account.id }`} dataPoint={ `Recipient_Phone_${ account.id }` } account={ account } accountProp="workPhoneNumber" />);
        result.emails.push(<RecipientItem key={ `Recipient_Email_${ account.id }`} dataPoint={ `Recipient_Email_${ account.id }` } account={ account } accountProp="emailAddress" onClick={ onClick } />);

        return result;
    }, { phones: [], emails: [] });

    const onAddPhone = evt => navigate("/advancedAlerts/addPhoneWorkflow");
    const onAddEmail = evt => navigate("/advancedAlerts/addEmailWorkflow");

    return (
        <div className="manage-recipients-content back-link-padding">
            <Link to="/advancedAlerts" className="back-link">
                <span><SVGAsset id="LeftChevronIcon" /> Back</span>
            </Link>

            <p className="page-subtitle">Manage Recipients</p>

            <FormContainer className="small-form-width">
                <FormButtonRow>
                    <UIButton className="primary-button" text="Add Phone" dataPoint="Manage_Recipients_Add_Phone_Button" onClick={ onAddPhone } />
                    <UIButton className="primary-button" text="Add Email" dataPoint="Manage_Recipients_Add_Email_Button" onClick={ onAddEmail } />
                </FormButtonRow>

                <FormRowView>
                    <div className="flex-container flex-vertical recipient-container">
                        { emails }
                        { phones }
                    </div>
                </FormRowView>
            </FormContainer>
        </div>
    );
}

function RecipientItem(props) {
    const account = props.account ?? UserAccount.firstInstanceOf();
    const accountProp = props.accountProp ?? "emailAddress";
    const dataPointLabel = props.dataPoint ? { "data-point": `${ props.dataPoint }_Recipient_Item_Label` } : {};
    const dataPointChevron = props.dataPoint ? { "data-point": `${ props.dataPoint }_Recipient_Item_Chevron` } : {};

    const onClick = props.onClick ?? undefined;
    const value = account[ accountProp ];

    const displayValue = accountProp === "workPhoneNumber"
        ? `(${ value.slice(0, 3) }) ${ value.slice (3, 6) }-${ value.slice(6) }`
        : value;

    return (
        <div className="flex-container flex-horizontal clickable recipient" onClick={ onClick }>
            <p className="flex-width">
                <span { ... dataPointLabel }>{ displayValue }</span>
            </p>
            <SVGAsset id="RightChevronIcon" className="set-width" { ... dataPointChevron } />
        </div>
    );
}

function DisabledRecipientItem(props) {
    return (
        <DisabledPrompt>
            <RecipientItem { ...props } />
        </DisabledPrompt>
    );
}